import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { PhoenixDirectivesModule } from 'app/directives/directives.module';
import { ValidationErrorsModule } from '../validation-errors/validation-errors.module';
import { IntecDatePickerComponent } from './intec-date-picker.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { DateModule } from 'app/main/content/misc/date.module';

@NgModule({
    declarations: [
        IntecDatePickerComponent,
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatInputModule,
        MatDatepickerModule,
        FuseSharedModule,
        ValidationErrorsModule,
        PhoenixDirectivesModule,
        DateModule,
    ],
    exports: [
        IntecDatePickerComponent,
    ]
})
export class IntecDatePickerModule
{
}
